import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useModal } from 'components/modal-views/context';
import Logo from 'layouts/logo/logo';
// @ts-ignore
import LogoImage from 'assets/images/logo.svg';
import { Button, ButtonsGrid } from 'components/common/button/button';
import { useAppDispatch } from 'redux/use-hooks';
import { connectWalletAndResolveAccess } from 'utils/connect-wallet-and-resolve-access';
import { TERMS_PAGE, PRIVACY_PAGE } from 'site-settings/site-navigation';

import {
  StyledFullHeightCont,
  StyledWrapper,
  StyledContainer
} from 'assets/styles/pages.style';
import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

const AgreementText = styled.p`
  margin-top: 20px;
  text-align: center;
  font-size: ${themeGet('fontSizes.sm')}px;
  line-height: 1.5;
  color: ${themeGet('colors.primary.extra')};
`;

const AgreementLink = styled(Link)`
  font-weight: ${themeGet('fontWeights.semi')};
  text-decoration: underline;
  color: ${themeGet('colors.primary.regular')};
`;

const SignInPage = () => {
  const { openModal, closeModal } = useModal();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleSignIn = async () => {
    setIsSigningIn(true);
    try {
      await connectWalletAndResolveAccess({
        dispatch,
        openModal,
        closeModal,
        navigate,
        forceConnect: true
      });
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <StyledFullHeightCont>
      <StyledWrapper>
        <StyledContainer>
          <Logo text="Wallet" imageUrl={LogoImage} />

          <ButtonsGrid>
            <Button
              fullwidth
              onClick={handleSignIn}
              disabled={isSigningIn}
              loading={isSigningIn}
            >
              Sign In With Near
            </Button>
            <Button
              fullwidth
              variant="secondary"
              onClick={() => openModal('TERM_VIEW')}
              disabled={isSigningIn}
            >
              Create Near Account
            </Button>
          </ButtonsGrid>

          <AgreementText>
            By clicking Create a new account, Sign in, you agree to our{' '}
            <AgreementLink to={TERMS_PAGE} target="_blank" rel="noopener noreferrer">
              Terms and Conditions
            </AgreementLink>{' '}
            and{' '}
            <AgreementLink
              to={PRIVACY_PAGE}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </AgreementLink>
            .
          </AgreementText>
        </StyledContainer>
      </StyledWrapper>
    </StyledFullHeightCont>
  );
};

export default SignInPage;
